import { Estabelecimento } from '../estabelecimento/estabelecimento.model'
import { OperadoraDeMaquina } from '../operadora-de-maquina.model'
import { Detalhe } from './detalhe.model'
import { Transacao } from './transacao.model'

export class Agrupamento<T extends Transacao> {
    operadora: OperadoraDeMaquina
    bandeira: string
    transacao: T
    detalhes: Detalhe<T>[]
    estabelecimento: Estabelecimento

    inativacao(){        
        if (this.estabelecimento.status === 'Inativado ou Operadora fora do ar')
        return true        
    }

}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/extrato/agrupamento.model.ts